export const FirebaseConfig = {
	"projectId": "dexss-png-71aa4",
	"appId": "1:319239403552:web:b250c39353c9eef055a445",
	"databaseURL": "https://dexss-png-71aa4-default-rtdb.firebaseio.com",
	"storageBucket": "dexss-png-71aa4.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyD3JpBCvCnXfmK5OdDTc69XL5OxEjtSMiE",
	"authDomain": "dexss-png-71aa4.firebaseapp.com",
	"messagingSenderId": "319239403552",
	"measurementId": "G-RZXKJYJGGL"
};